import styled, { css } from 'styled-components'

import * as ds from '@bob/design-system'

export function Controls({
  onClickLeft,
  onClickRight,
}: {
  onClickLeft: () => void
  onClickRight: () => void
}): React.ReactElement {
  return (
    <Wrapper>
      <ds.CircularButton outlined onClick={onClickLeft}>
        <ds.icons.ChevronLeft size={32} />
      </ds.CircularButton>
      <ds.CircularButton outlined onClick={onClickRight}>
        <ds.icons.ChevronRight size={32} />
      </ds.CircularButton>
      <HalfTransparentBlock position="left" />
      <HalfTransparentBlock position="right" />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  ${ds.CircularButton} {
    position: absolute;
    top: 45%;
    z-index: 2;

    @media not screen and (${ds.breakpoint.TABLET}) {
      width: 40px;
      height: 40px;
      min-height: 40px;
      top: 55%;

      ${ds.icons.Icon} {
        width: 24px;
        height: 24px;
        line-height: 24px;
      }
    }
  }

  ${ds.CircularButton}:nth-child(1) {
    left: 3%;
  }
  ${ds.CircularButton}:nth-child(2) {
    right: 3%;
  }

  @media screen and (${ds.breakpoint.TABLET}) {
    ${ds.CircularButton}:nth-child(1) {
      left: 1%;
    }
    ${ds.CircularButton}:nth-child(2) {
      right: 1%;
    }
  }
`

export const HalfTransparentBlock = styled.div<{
  position: 'left' | 'right'
  color?: string
}>`
  height: 100%;
  width: 8%;
  position: absolute;
  top: 0;
  z-index: 1;
  pointer-events: none;

  ${({ color = ds.color.PINK, position }) => {
    let rgb = ''
    const pinkRgb = `255, 197, 170`
    const yellowRgb = `251, 218, 101`

    if (color === ds.color.PINK) {
      rgb = pinkRgb
    }
    if (color === ds.color.YELLOW) {
      rgb = yellowRgb
    }

    if (position === 'left') {
      return css`
        left: 0;
        background: linear-gradient(0.25turn, ${color}, ${color}, rgba(${rgb}, 0));
      `
    }
    if (position === 'right') {
      return css`
        right: 0;
        background: linear-gradient(0.25turn, rgba(${rgb}, 0), ${color}, ${color});
      `
    }
  }}
`
